<template>
    <v-app-bar
      dense
    >
      <v-toolbar-title
        elevation="0"
        class="text-center m-auto"
        full-width
      >
        <img src="../../../assets/images/todaystore/logo-logo-tr-b.svg"/>
      </v-toolbar-title>
    </v-app-bar>
</template>

<script>

export default {
  name: 'Header',
  components: {
  },
  data() {
    return {
    }
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
  header {
    padding-top: 8.5%;
    background-color: transparent !important;
    border-color: transparent !important;
    box-shadow: none !important;
  }
</style>
